export const PHONE_DISPLAY = "(765) 326-0111";
export const PHONE_HREF = "tel:7653260111";
export const EMAIL = "livengoodpallet66@gmail.com";
export const ADDRESS = "9024 W ST RD 28, Frankfort, Indiana 46041";
export const ARTICLE_URL =
  "https://palletenterprise.com/livengood-pallets-rebuilds-after-fire-with-wood-mizer-pallet-hawg-equipment/";
export const REVIEWS_URL = "https://share.google/s2BCApKgGaW2RGP2x";
export const MAP_QUERY = "9024 W ST RD 28, Frankfort, Indiana 46041";
export const MAP_LINK = `https://maps.google.com/?q=${encodeURIComponent(MAP_QUERY)}`;
export const MAP_EMBED_SRC = `https://www.google.com/maps?q=${encodeURIComponent(MAP_QUERY)}&output=embed`;
